export enum FormFieldKeySpecialTypeEnum {
    FirstName = 1,
    FirstNameJointLife = 2,
    LastName = 3,
    LastNameJointLife = 4,
    DateOfBirth = 5,
    DateOfBirthJointLife = 6,
    Gender = 7,
    GenderJointLife = 8,
    SmokingStatus = 9,
    SmokingStatusJointLife = 10,
    CoverAmount = 11,
    CoverAmountJointLife = 12,
    EmailAddress = 13,
    PhoneNumber = 14,
    Occupation = 15,
    OccupationalClass = 16,
    EmploymentType = 17,
    Term = 18,
    NRA = 19,
    DeferredPeriod = 20,
    NumberOfCovers = 21,
    IndexationAdmin = 22,
    TermsAndConditions = 23,
    BerRating = 24,
    PropertyValue = 25,
    Income = 26,
    SeriousIllnessCoverTypeAdmin = 27,
    SeriousIllnessCoverAmountAdmin = 28,
    ConvertibleOptionAdmin = 29,
    QuoteResultsActionAdmin = 30,
    IncomeProtectionCoverAmountAdmin = 31,
    IncomeProtectionCoverAmountAvailable = 32,
    SeriousIllnessCoverAmountJointLifeAdmin = 33,
    MortgageType = 34,
    NotesAdmin = 35,
    QuoteReferenceNo = 36,
    Title = 37,
    MaritalStatus = 38,
    County = 39,
    Country = 40,
    Address = 41,
    City = 42,
    ConditionDetails = 43,
    Height = 44,
    Weight = 45,
    Provider = 46,
    HealthStatusQuestion = 47,
    DeclarationStatement = 48,
    SmokingStatusQuestion = 49,
    WeightUnit = 50,
    HeightUnit = 51,
    NRAJointLife = 52,
    Aviation = 53,
    Climbing = 54,
    Diving = 55,
    Equestrianism = 56,
    ExtremeSport = 57,
    Gliding = 58,
    HangGliding = 59,
    MotorSport = 60,
    Parachuting = 61,
    Sailing = 62,
    HazardousOccupation = 63,
    BloodPressureCholesterol = 64,
    Asthma = 65,
    MentalHealth = 66,
    BackDisorder = 67,
    JointDisorder = 68,
    Diabetes = 69,
    MedicalConditions = 70,
    Alcohol = 71,
    Anaemia = 72,
    Arthritis = 73,
    ChestPain = 74,
    CrohnDisease = 75,
    Cysts = 76,
    Drugs = 77,
    Epilepsy = 78,
    GastricReflux = 79,
    Gynaecological = 80,
    GynaecologicalDisorder = 81,
    HearthMurmur = 82,
    BowelDisease = 83,
    BowelSyndrome = 84,
    KindeyUrinaryDisorder = 85,
    HearingLoss = 86,
    NeurologicalDisorder = 87,
    RespiratoryDisorder = 88,
    Smoking = 89,
    StomachGastroDisorder = 90,
    ThyroidDisorder = 91,
    UlcerativeColitis = 92,
    OverseasTravel = 93,
    Product = 94,
    ProductType = 95,
    FundNamesAllocationSplit = 96,
    Amc = 97,
    MonthlyContributionAmount = 98,
    InvestedAmount = 99,
    ManualProductNumberOfCovers = 100,
    Commission = 101,
    MonthlyPremium = 102,
    ContributionType = 103,
    FundChoice = 104,
    FundValue = 105,
    PolicyStartDate = 106,
    Iban = 107,
    Bic = 108,
    PpsNumber = 109,
    TitleJointLife = 110,
    MaritalStatusJointLife = 111,
    EmailAddressJointLife = 112,
    PhoneNumberJointLife = 113,
    OccupationJointLife = 114,
    EmploymentTypeJointLife = 115,
    CountyJointLife = 116,
    CountryJointLife = 117,
    AddressJointLife = 118,
    CityJointLife = 119,
    PpsNumberJointLife = 120,
    HomePhoneNumber = 121,
    HomePhoneNumberJointLife = 122,
    FirstFactFind = 123,
    RecommendedProductValuesOverride = 124,
    CoverAmountOverride = 125,
    CoverAmountJointLifeOverride = 126,
    MonthlyPremiumOverride = 127,
    TermOverride = 128,
    IndexationOverride = 129,
    ConvertibleOverride = 130,
    DeferredPeriodOverride = 131,
    GrossAnnualSalary = 132,
    GrossAnnualSalaryJointLife = 133,
    NetMonthlyIncomeSalaryEstimated = 134,
    NetMonthlyIncomeSalaryEstimatedJointLife = 135,
    LumpSumContributionAmount = 137,
    CompanyName = 138,
    AnySelectedProductNumberOfCovers = 139,
    HasLifeOfAnother = 140,
    IsLifeInsuranceSelected = 141,
    IsMortgageProtectionSelected = 142,
    IsIllnessCoverSelected = 143,
    IsIncomeProtectionSelected = 144,
    IsExecutiveIncomeProtectionSelected = 145,
    IsSeriousIllnessCoverAttached = 146,
    AttachedSeriousIllnessCoverType = 147,
    SeriousIllnessCoverAmountAdminOverride = 148,
    SeriousIllnessCoverAmountAdminJointLifeOverride = 149,
}